// Tailwind class strings shared by the toolbar's own buttons and the bootstrap-vue dropdowns in it,
// whose toggle and menu elements only accept a class string.

const FOCUS_RING = 'focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-primary focus-visible:tw-ring-offset-2';

export const ICON_BUTTON = 'tw-relative tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-p-0 tw-leading-none '
  + 'tw-rounded-[10px] tw-cursor-pointer tw-text-primary-ink tw-transition-colors hover:tw-bg-light-bg hover:tw-text-primary '
  + FOCUS_RING;

export const ACTIVE = 'tw-bg-light-bg tw-text-primary';

// the dropdown's root li carries `tw-group` and bootstrap-vue adds `.show` to it while the menu is open
export const DROPDOWN_OPEN = 'group-[.show]:tw-bg-light-bg group-[.show]:tw-text-primary';

export const AVATAR_TOGGLE = 'tw-flex tw-items-center tw-gap-1 tw-h-[42px] tw-ml-1.5 tw-pl-1 tw-pr-1.5 tw-leading-none '
  + 'tw-rounded-full tw-transition-colors hover:tw-bg-light-bg ' + FOCUS_RING;

export const BADGE = 'tw-absolute tw-top-0.5 tw-right-0.5 tw-ring-2 tw-ring-white';
